import { Col, Row } from 'react-bootstrap';

import './PercentValueBar.scss';

export type PercentValueBarProps = {
  title: string;
  percent: number;
};

export const PercentValueBar: React.FC<PercentValueBarProps> = ({
  title,
  percent,
}) => {
  return (
    <div className="d-flex percent-value-bar">
      <Row className="w-100 align-items-center">
        <Col className="col-4">
          <span className="title">{title}</span>
        </Col>
        <Col className="col-7">
          <div className="activity-bar">
            <div
              style={{ width: `${percent}%` }}
              className="percentage-bar"
            ></div>
          </div>
        </Col>
        <Col className="col-1 percent-container">
          <span className="percent-value">{percent}%</span>
        </Col>
      </Row>
    </div>
  );
};
